import { render, staticRenderFns } from "./Icaur.vue?vue&type=template&id=18c00fa3&scoped=true"
import script from "./Icaur.vue?vue&type=script&lang=js"
export * from "./Icaur.vue?vue&type=script&lang=js"
import style0 from "./Icaur.vue?vue&type=style&index=0&id=18c00fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c00fa3",
  null
  
)

export default component.exports